/**
 * 主模块
 * @author yuxin.zhang
 * @Date 2017-05-09
 */

import React from 'react';
import { observer, inject } from 'mobx-react';
import { Dialog } from '@ok/okd';

import RootContext from '_common/container/RootContext';
import { messenger } from '_common/utils/Messenger';

class TipsDialog extends RootContext {
  UNSAFE_componentWillMount() {
    messenger.onMessage('showPromptDialog', (message) => {
      const dialog = Dialog.prompt({
        title: message,
        confirmText: this.translate('user.operation.gotIt'),
        onConfirm: () => {
          dialog.destroy();
        },
      });
    });
  }

  render() {
    const { loadingStore } = this.props;
    return (
      <Dialog.Prompt
        visible={loadingStore.showErrDialog}
        infoType={loadingStore.infoType}
        confirmText={this.translate('user.operation.gotIt')}
        onConfirm={() => {
          return loadingStore.hideErrorDialog();
        }}
        onClose={() => {
          return loadingStore.hideErrorDialog();
        }}
        title={loadingStore.errorMsg}
      />
    );
  }
}

export default inject('loadingStore')(observer(TipsDialog));
